import { FC } from "react";

import { Box, Divider, Link, Stack, Theme, Typography } from "@mui/material";

import { useOrganization } from "../../providers";
import { formatDashedDate, parseWallClockDate } from "../../utils/dateHelpers";

export const Footer: FC<{ frontendUrl: string; isAuthenticated: boolean; lastPayDate: string | null; theme: Theme }> = ({
  frontendUrl,
  isAuthenticated,
  lastPayDate,
  theme,
}) => {
  const { configuration } = useOrganization();

  return (
    <Box
      bgcolor="primary.main"
      color={theme.palette.overrides.footerText.main}
      display="grid"
      gap={1}
      gridTemplateColumns="1fr auto 1fr"
      overflow="auto"
      px={1}
      py={0}
      sx={{
        textWrap: "nowrap",
        "& .MuiTypography-root": {
          color: "inherit",
        },
      }}
      width="100%"
      zIndex={theme.zIndex.drawer + 1}
    >
      <Typography variant="body2">
        {!!lastPayDate && !!isAuthenticated ? `Last Pay Date: ${formatDashedDate(parseWallClockDate(lastPayDate))}` : ""}
      </Typography>
      <Stack direction="row" flexGrow={1} gap={1} justifyContent="center">
        <Typography component={Link} href={`mailto:${configuration.branding.contactEmail}`} variant="body2">
          Have Questions? Contact us at {configuration.branding.contactEmail}
        </Typography>
        <Divider orientation="vertical" sx={{ my: 0.5 }} flexItem />
        <Typography variant="body2">&copy; Copyright 2025-2026</Typography>
        <Typography component={Link} href={`${frontendUrl}/privacy-policy.htm`} rel="noopener noreferrer" target="_blank" variant="body2">
          Privacy
        </Typography>
        <Typography
          component={Link}
          href={`${frontendUrl}/terms-and-conditions.htm`}
          rel="noopener noreferrer"
          target="_blank"
          variant="body2"
        >
          Terms
        </Typography>
      </Stack>
      <Box />
    </Box>
  );
};
